<template>
  <div class="iDalgo-Survey">
    <component v-if="surveyIsLoaded" v-bind:is="surveyType" @click="vote" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import iDalgoSurveyNote from '@/components/iDalgo-Survey/iDalgo-Survey-Note'
import iDalgoSurveySimpleChoice from '@/components/iDalgo-Survey/iDalgo-Survey-Simple-Choice'
import iDalgoSurveyQuiz from '@/components/iDalgo-Survey/iDalgo-Survey-Quiz'

export default {
  name: 'iDalgo-Survey',
  components: {
    iDalgoSurveyNote,
    iDalgoSurveySimpleChoice,
    iDalgoSurveyQuiz
  },
  computed: {
    ...mapGetters({
      survey: 'survey/survey'
    }),
    surveyIsLoaded () {
      return (this.survey && this.survey.type)
    },
    surveyType () {
      return this.surveyIsLoaded ? `iDalgoSurvey${this.survey.type.charAt(0).toUpperCase()}${this.survey.type.slice(1)}` : null
    }
  },
  methods: {
    vote (userVotes) {
      this.$store.dispatch('survey/vote', userVotes)
    }
  }
}
</script>

<style lang="scss"></style>
